import { NextPage } from 'next'
import { ELanguage } from '@microfrontends/react-components'
import MainLayout from '../../containers/MainLayout'
import IPageProps from '../../services/models'
import JobSearchContainer from '../../containers/JobSearchContainer'
import { ISSRJobSearchProps, getServerSideProps } from '../../ssr/jobSearch'
import { EPages } from '@microfrontends/app-shell-v2'
import { getCurrentDatetime } from '../../util/dateFormat'
import { convertMetaInfo } from '../../util/convertMetaInfo'

const JobSearchPage: NextPage<IPageProps & ISSRJobSearchProps> = (props) => {
	const { metaData, ...rest } = props
	const datetime = getCurrentDatetime()

	return (
		<MainLayout
			{...rest}
			t={() => ''}
			languageCode={ELanguage.VI}
			metaCanonical={metaData?.canonicalUrl || `${process.env.APP_BASE_URL}/tim-viec-lam`}
			pageName={EPages.SEO_LANDING_PAGE}
			metaKeywords='tuyển dụng, việc làm, tìm việc làm, tìm việc nhanh, tìm việc, tìm việc 24h'
			metaTitle={
				convertMetaInfo(metaData?.title) ||
				`Tuyển dụng, tìm việc làm 24h nhanh, mới nhất ${datetime} - Vietnamworks`
			}
			metaDescription={
				convertMetaInfo(metaData?.description) ||
				'Hơn 10,000+ việc làm marketing, nhân sự, kế toán, tài chính lương cao, chế độ đãi ngộ cực tốt tại công ty hàng đầu. Tìm việc làm toàn quốc nhanh chóng, cập nhật mới mỗi ngày, tuyển dụng hiệu quả tại VietnamWorks!'
			}
			responsiveCornerColor='#F4F4F7'
		>
			<JobSearchContainer langCode={ELanguage.VI} {...props} />
		</MainLayout>
	)
}
export default JobSearchPage
export { getServerSideProps }
